import { CalcDetail, Calculation, Field, Item } from '../models.ts';

class CalculatorService {

    private currCalc: Calculation;
    private currField: Field;
    private itemMap: any;

    calculate(calculation: Calculation, itemMap: any) {
        calculation.sqft = calculation.subTotal = calculation.total = 0;
        // #region agent log
        if (calculation.id === 'deck') { fetch('http://127.0.0.1:7898/ingest/b0e7ed10-47f0-442f-b104-b0c53c99e94b',{method:'POST',headers:{'Content-Type':'application/json','X-Debug-Session-Id':'b28055'},body:JSON.stringify({sessionId:'b28055',location:'CalculatorService.ts:calculate',message:'deck calc start',data:{heightSelection:calculation['height']?.selection,sqft:calculation.sqft,handicapRampSelection:calculation['handicapRamp']?.selection},timestamp:Date.now(),hypothesisId:'H1-H5'})}).catch(()=>{}); }
        // #endregion
        // console.log('calculation', JSON.parse(JSON.stringify(calculation)))
        this.itemMap = itemMap;
        this.currCalc = new Calculation(calculation);
        Object.keys(calculation).forEach(key => {
            if (!this.currCalc[key]) {
                this.currCalc[key] = calculation[key]
            }
        });

        for (let i = 0; i < 3; i++) {
            if(i === 2) {
                this.currCalc.total += this.currCalc.subTotal;
            }
            this.currCalc.fields.forEach((field: Field) => {
                if (field.calcGroup === i) {
                    this.currField = new Field(JSON.parse(JSON.stringify(this.currCalc[field.id])));
                    this.currField.calc?.forEach((calc: CalcDetail) => {
                        let calcDetail = new CalcDetail(calc);
                        let values: number[] = []
                        this.getCalcFieldValues(calcDetail, values);
                        this.currCalc[this.currField.id].value = calcDetail.value = this.performOperation(calcDetail.type, values);
                        // #region agent log
                        if (this.currField.id === 'handicapRamp') { fetch('http://127.0.0.1:7898/ingest/b0e7ed10-47f0-442f-b104-b0c53c99e94b',{method:'POST',headers:{'Content-Type':'application/json','X-Debug-Session-Id':'b28055'},body:JSON.stringify({sessionId:'b28055',location:'CalculatorService.ts:handicapRamp',message:'handicapRamp calc',data:{calcType:calcDetail.type,operandIds:calcDetail.fields?.map(f=>({id:f.id,type:f.type})),values,result:calcDetail.value,subTotalBefore:this.currCalc.subTotal,heightUpper:this.currCalc['height']?.selection?.upperValue,heightLower:this.currCalc['height']?.selection?.lowerValue,sqft:this.currCalc.sqft,rampPrice:this.currCalc['handicapRamp']?.selection?.price},timestamp:Date.now(),hypothesisId:'H1-H3'})}).catch(()=>{}); }
                        // #endregion
                        if (calcDetail.result?.resultId) {
                            let valueList = [calcDetail.value, this.currCalc[calcDetail.result.resultId]];
                            this.currCalc[calcDetail.result.resultId] = this.performOperation(calcDetail.result.type, valueList);
                        }
                    });
                }
            });
        }
        this.currCalc.subTotal = Math.ceil(this.currCalc.subTotal);
        this.currCalc.total = Math.ceil(this.currCalc.total);
        // #region agent log
        if (this.currCalc.id === 'deck') { fetch('http://127.0.0.1:7898/ingest/b0e7ed10-47f0-442f-b104-b0c53c99e94b',{method:'POST',headers:{'Content-Type':'application/json','X-Debug-Session-Id':'b28055'},body:JSON.stringify({sessionId:'b28055',location:'CalculatorService.ts:calculate-end',message:'deck calc end',data:{subTotal:this.currCalc.subTotal,handicapRampValue:this.currCalc['handicapRamp']?.value,expectedRampAdd:(this.currCalc['handicapRamp']?.selection?.price||0)*(this.currCalc['height']?.selection?.upperValue??this.currCalc['height']?.selection?.lowerValue??0)},timestamp:Date.now(),hypothesisId:'H1'})}).catch(()=>{}); }
        // #endregion
        // console.log('currCalc', JSON.parse(JSON.stringify(this.currCalc)))
        return this.currCalc;
    }

    private checkDependency(field: Field) {
        if (field.dependency && this.findValue(this.currCalc[this.currField.id]) && this.findValue(this.currCalc[this.currField.id]) !== 0) {
            let depField = this.currCalc[field.dependency.depId];
            if (field.dependency.type === 'select') {
                let itemList: Item[] = this.itemMap[depField.collection];
                for (let item of itemList) {
                    if (item.lowerValue || item.upperValue) {
                        if ((item.lowerValue && item.upperValue &&
                            depField.value >= item.lowerValue && depField.value <= item.upperValue)
                            || (!item.lowerValue && item.upperValue && depField.value <= item.upperValue)
                            || (item.lowerValue && !item.upperValue && depField.value >= item.lowerValue)
                        ) {
                            this.currCalc[field.dependency.depId].selection = item;
                            break;
                        }
                    } else if (item.name === this.findValue(depField, depField.type === 'select' ? 'price' : 'value')) {
                        this.currCalc[field.dependency.depId].selection = item;
                        break;
                    } else {
                        let defaultSelection = depField.selection?.id ? itemList.find(i => i.id === depField.selection?.id) : depField.selection;
                        this.currCalc[field.dependency.depId].selection = defaultSelection;
                    }
                }
            } else if (field.dependency.depValue) {
                let value = field.type === 'self'
                    ?
                    this.getDefaultValue(this.currCalc[this.currField.id])
                    :
                    this.getDefaultValue(this.currCalc[field.id]);
                switch (field.dependency.depType) {
                    case 'over':
                        if (this.findValue(depField) > field.dependency.depValue) {
                            value = field.dependency.type === 'substitute'
                                ? field.dependency.value
                                : this.performOperation(field.dependency.type, [value, field.dependency.value]);
                        }
                        break;
                    case 'under':
                        if (this.findValue(depField) < field.dependency.depValue) {
                            value = field.dependency.type === 'substitute'
                                ? field.dependency.value
                                : this.performOperation(field.dependency.type, [value, field.dependency.value]);
                        }
                        break;
                    default:
                        break;
                }
                this.currCalc[this.currField.id].selection[this.currField.type === 'select' ? 'price' : 'value'] = value;
            }
        }
    }

    private getDefaultValue(field) {
        if (field.type === 'select' && field.collection && field.selection) {
            for (let item of this.itemMap[field.collection]) {
                if (item.id === field.selection.id) {
                    return item.price;
                }
            }
        }
        return this.findValue(field);
    }

    private getCalcFieldValues(calc: CalcDetail, values: number[]) {
        calc.fields.forEach(item => {
            this.checkDependency(item);
            switch (item.type) {
                case 'parent':
                    if (item.id && this.currCalc[item.id]) {
                        let val = this.findValue(this.currCalc[item.id], item.property);
                        // #region agent log
                        if (this.currField.id === 'handicapRamp') { fetch('http://127.0.0.1:7898/ingest/b0e7ed10-47f0-442f-b104-b0c53c99e94b',{method:'POST',headers:{'Content-Type':'application/json','X-Debug-Session-Id':'b28055'},body:JSON.stringify({sessionId:'b28055',location:'CalculatorService.ts:getCalcFieldValues-parent',message:'handicapRamp parent operand',data:{parentId:item.id,property:item.property,value:val},timestamp:Date.now(),hypothesisId:'H2'})}).catch(()=>{}); }
                        // #endregion
                        values.push(val);
                    }
                    break;
                case 'self':
                    if (item.id) {
                        let val = this.findValue(this.currCalc[this.currField.id], item.id);
                        values.push(val);
                    }
                    break;
                default:
                    break;
            }
        });
    }

    private findValue(obj, property?: string) {
        if (obj instanceof Object) {
            if (obj.selection) {
                if (!property) {
                    property = obj.type === 'select' ? 'price' : 'value';
                }
                this.checkDependency(obj.selection);
                const value = obj.selection[property];
                if (property === 'upperValue' && (value === null || value === undefined)) {
                    return obj.selection.lowerValue;
                }
                return value;
            } else {
                return property ? obj[property] : obj.value;
            }
        }
        return obj;
    }

    private performOperation(calcType: string | null, values: number[]) {
        let result;
        switch (calcType) {
            case 'add':
                result = this.addValues(values);
                break;
            case 'multiply':
                result = this.multiplyValues(values);
                break;
            case 'substitute':
                result = this.currCalc[this.currField.id].value;
                break;
            default:
                break;
        }
        return result;
    }

    private addValues(values: number[]) {
        let result = 0;
        values.forEach(val => {
            if (val) {
                result += val;
            }
        });
        return result;
    }

    private multiplyValues(values: number[]) {
        let result = 0;
        values.forEach((val, index) => {
            if (val) {
                if (result === 0 && index === 0) {
                    result = val;
                } else {
                    result *= val;
                }
            }
        });
        return result;
    }

}

export default CalculatorService;